<div class="container-fluid ptCustom">

    <div class="row">
        <div class="col-12 my-2">
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4">
                    <div class="row align-items-end">
                        <div class="input-group mb-3 mb-xl-0">
                            <input (keyup)="enterSearchTerm($event)" [(ngModel)]='searchText' type="text"
                                class="form-control form-control-lg" placeholder="search payments...">
                            <!--<button class="btn btn-lg btn-db border-lb dropdown-toggle" type="button" id="searchFilter" data-bs-toggle="dropdown" aria-expanded="false">
                                Status: Active
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="searchFilter">
                                <li><a class="dropdown-item" href="#">Status: All</a></li>
                                <li><a class="dropdown-item" href="#">Status: Deactivated</a></li>
                            </ul>-->
                            <button type="button" (click)="hitSearchBtn()" class="btn btn-lg btn-sb border-lb"><i
                                    class="fas fa-search"></i></button>
                            <button type="button" (click)="clearSearch()" class="btn btn-lg btn-primary border-lb"><i
                                    class="fas fa-times"></i></button>
                        </div>
                        <div class="search-filters py-2">
                            <!-- hide if none -->
                            <ul class="filter-tags" *ngIf="keywordSearches.length > 0">
                                <li (click)="removeSearchTerm(search)" *ngFor="let search of keywordSearches"
                                    class="tag">
                                    <span>{{search}}</span><span class="remove-tag"><i
                                            class="fa fa-times-circle"></i></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-3">
                            <div class="dropdown w-100">
                                <label for="invoiceFilter1" class="form-label">Date Range</label>
                                <input type="text" id="filterDateRange" #input class="form-control form-control-lg" [(ngModel)]="dateInput" (click)="inputClick()">
                                <!--<mbsc-input class="form-control" #input [(ngModel)]="dateInput" inputStyle="box"
                                            labelStyle="stacked" (click)="inputClick()" type="text"></mbsc-input>-->
                            </div>
                            <mbsc-popup class="demo-date-filtering-popup" [anchor]="inputElm" [responsive]="respPopup"
                                        #popup>
                                <div class="mbsc-grid mbsc-no-padding">
                                    <div class="mbsc-row">
                                        <div class="mbsc-col-sm-4 mbsc-push-sm-8 demo-date-filtering-dates">
                                            <div class="demo-date-filtering-inputs">
                                                <mbsc-select [(ngModel)]="dateSelector" [data]="myData"
                                                             label="Date range" inputStyle="box" labelStyle="stacked"
                                                             [options]="selectOptions"></mbsc-select>
                                                <mbsc-input #start label="Start" inputStyle="box" labelStyle="stacked"
                                                            [disabled]="disableDateInput"></mbsc-input>
                                                <mbsc-input #end label="End" inputStyle="box" labelStyle="stacked"
                                                            [disabled]="disableDateInput"></mbsc-input>
                                            </div>
                                            <div class="demo-date-filtering-desktop-buttons mbsc-button-group-justified">
                                                <mbsc-button class="apply-button"
                                                             (click)="applyClick()">Apply</mbsc-button>
                                                <mbsc-button class="cancel-button"
                                                             (click)="cancelClick()">Cancel</mbsc-button>
                                            </div>
                                        </div>
                                        <div class="mbsc-col-sm-8 mbsc-pull-sm-4">
                                            <mbsc-datepicker [(ngModel)]="selectedDate" [startInput]="start"
                                                             [endInput]="end" [options]="calendarOptions"></mbsc-datepicker>
                                        </div>
                                    </div>
                                </div>
                            </mbsc-popup>
                        </div>
                        <div class="col-lg-3">
                            <div class="mbsc-col-sm-12 mbsc-col-md-6">
                                <label for="invoiceFilter2" class="form-label">Member</label>
                                <input id="memberSearchFancyInput" #memberSelect class="mobi-input form-control form-control-lg" [(ngModel)]="memberInputString" (click)="activateSelect()" placeholder="Please select..." />
                                <mbsc-select [selectMultiple]="true" [data]="membersForFilter" [(ngModel)]="memberInput"
                                             display="anchored" [filter]="true" [options]="remoteOptions" [anchor]="memberSelect"
                                             labelStyle="stacked" inputStyle="box" placeholder="Please select..." (onChange)="setMemberText($event)" hidden #select ></mbsc-select>
                            </div>
                        </div>
                        <!-- <div class="col-lg-3">
                            <button class="btn btn-lg btn-db border-lb dropdown-toggle" type="button" id="searchFilter"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Status: {{statusSearch.display}}
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="searchFilter">
                                <li><a *ngIf="statusSearch.value != -1" (click)="changeStatusSearch(-1)"
                                        class="dropdown-item" href="javascript:void(0)">Status: All</a></li>
                                <li><a *ngIf="statusSearch.value != 0" (click)="changeStatusSearch(0)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Invoiced</a></li>
                                <li><a *ngIf="statusSearch.value != 0" (click)="changeStatusSearch(4)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Unpaid</a></li>
                                <li><a *ngIf="statusSearch.value != 1" (click)="changeStatusSearch(1)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Partially Paid</a></li>
                                <li><a *ngIf="statusSearch.value != 2" (click)="changeStatusSearch(2)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Paid In Full</a></li>
                                <li><a *ngIf="statusSearch.value != 3" (click)="changeStatusSearch(3)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Past Due</a></li>
                                <li><a *ngIf="statusSearch.value != -9999" (click)="changeStatusSearch(-9999)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Cancelled</a></li>
                            </ul>
                        </div> -->
                        <!-- <div class="col-lg-3">
                            <label for="invoiceFilter2" class="form-label">Filter</label>
                            <select class="form-select" aria-label="invoiceFilter2" id="invoiceFilter2">
                                <option selected>All</option>
                                <option value="1">filter</option>
                            </select>
                        </div> -->
                    </div>
                    <div class="d-flex align-items-center justify-content-between mt-4 pt-4 border-top border-50 mb-4 ">
                        <div>
                            <div class="fs-5 fst-italic">viewing {{itemStart}}-{{itemEnd}} of {{filteredPayments}}
                                payments</div>
                        </div>
                        <button (click)="downloadCsv()" type="button" class="btn btn-add text-strong hvr-grow px-4"><i
                                class="fa-solid fa-download"></i> download as CSV</button>
                    </div>
                    <div class="card no-shadow border border-db bg-db p-2">
                        <div class="">
                            <table class="table table-hover align-middle m-0">
                                <thead>
                                    <tr>
                                        <th>
                                            <a (click)="changeSortType(1)" href="javascript:void(0)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 1}" class="icon">
                                                    <i class="far fa-long-arrow-alt-up"></i>
                                                </span>
                                                <span [ngClass]="{'active': sortType == 2}" class="icon">
                                                    <i class="far fa-long-arrow-alt-down"></i>
                                                </span>
                                            </a>Member
                                        </th>
                                        <th>
                                            <a (click)="changeSortType(2)" href="javascript:void(0)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 3}" class="icon">
                                                    <i class="far fa-long-arrow-alt-up"></i>
                                                </span>
                                                <span [ngClass]="{'active': sortType == 4}" class="icon">
                                                    <i class="far fa-long-arrow-alt-down"></i>
                                                </span>
                                            </a>Date
                                        </th>
                                        <th>For</th>
                                        <th>
                                            <a (click)="changeSortType(3)" href="javascript:void(0)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 5}" class="icon">
                                                    <i class="far fa-long-arrow-alt-up"></i>
                                                </span>
                                                <span [ngClass]="{'active': sortType == 6}" class="icon">
                                                    <i class="far fa-long-arrow-alt-down"></i>
                                                </span>
                                            </a>Amount
                                        </th>
                                        <!-- <th class="text-end">Actions</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let payment of payments">
                                        <td>
                                            <div>{{payment.paidByName}}</div>
                                            <small class="text-muted">{{payment.memberName}}</small>
                                        </td>
                                        <td>
                                            {{payment.dateString}}
                                        </td>
                                        <td>
                                            {{payment.reasonString}}
                                        </td>
                                        <td>
                                            {{payment.amountString}}
                                        </td>
                                        <!-- <td class="text-end">
                                            <div class="dropdown">
                                                <button class="btn btn-lg btn-outline-dark action-btn" type="button"
                                                    id="dropdownMenuButton1" data-bs-toggle="dropdown"
                                                    aria-expanded="false">
                                                    <i class="far fa-ellipsis-v"></i>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end"
                                                    aria-labelledby="dropdownMenuButton1">
                                                    <li><a class="dropdown-item" href="javascript:void(0);"><i
                                                                class="fa-light fa-eye fa-fw"></i> actions?</a></li>
                                                </ul>
                                            </div>
                                        </td> -->
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <nav aria-label="table navigation" class="d-flex align-items-center justify-content-center">
                            <ngb-pagination class="pagination mb-0" [maxSize]="5" [ellipses]="true"
                                [collectionSize]="filteredPayments" [(page)]="currentPageNum" [pageSize]="itemsPerPage">
                            </ngb-pagination>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>